// DEPENDENCIES //
import { updateOffspring } from '../../utils/api';
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

// COMPONENTS //
import BrushButton from '../BrushButton';


// STYLES //
import "./editZombie.css"

export default function EditZombie({ zombie, setZombie }) {

    // STATE //
    const navigate = useNavigate()
    const { _id } = zombie



    function handleChange(event) {
        setZombie({ ...zombie, "age": event.target.value })
    }



    const handleSubmit = async (event) => {
        event.preventDefault();
        await updateOffspring(zombie);
        await navigate("/chase");
    };


    return (
        <div>
            <form className="edit_form" onSubmit={handleSubmit}>
                <label htmlFor="age" className="sr-only">
                    How many years slip by?
                </label>

                <select
                    id="age"
                    name="age"
                    type="number"
                    onChange={handleChange}
                    value={zombie.age || ""}
                    required
                >
                        <option value="" disabled>
                            How many years slip by?
                        </option>
                        
                        <option value="2">2</option>
                        <option value="4">4</option>
                        <option value="6">6</option>
                </select>

                <BrushButton className="age-button" type="submit">
                    Age My Baby
                </BrushButton>
            </form>
        </div>
    );
}